import type { BacklogHttpResponse as BacklogHttpResponseContract } from "../contracts/api/BacklogHttpResponse";
import {
	parseHttpContentType,
	parseHttpWWWAuthenticate,
} from "../utils/BacklogUtil";

export class BacklogHttpResponse implements BacklogHttpResponseContract {
	readonly ok: boolean;
	readonly headers: Headers;

	constructor(private readonly options: { readonly response: Response }) {
		this.ok = options.response.ok;
		this.headers = options.response.headers;
	}

	getStatus(): number {
		return this.options.response.status;
	}

	getHeader(name: string): string {
		return this.options.response.headers.get(name) || "";
	}

	getWWWAuthenticate(): { scheme: string; params: Map<string, string> } {
		return parseHttpWWWAuthenticate(this.getHeader("www-authenticate"));
	}
	getContentType(): { mediaType: string; params: Map<string, string> } {
		return parseHttpContentType(this.getHeader("content-type"));
	}
	getRateLimitLimit(): number {
		return Number.parseInt(this.getHeader("x-ratelimit-limit"), 10);
	}
	getRateLimitRemaining(): number {
		return Number.parseInt(this.getHeader("x-ratelimit-remaining"), 10);
	}
	getRateLimitReset(): number {
		return Number.parseInt(this.getHeader("x-ratelimit-reset"), 10);
	}

	text(): Promise<string> {
		return this.options.response.text();
	}

	json(): Promise<unknown> {
		return this.options.response.json();
	}

	blob(): Promise<Blob> {
		return this.options.response.blob();
	}

	arrayBuffer(): Promise<ArrayBuffer> {
		return this.options.response.arrayBuffer();
	}
}
